import { render } from "./PagePiling.vue?vue&type=template&id=715eddfd"
import script from "./PagePiling.vue?vue&type=script&lang=js"
export * from "./PagePiling.vue?vue&type=script&lang=js"

import "./PagePiling.vue?vue&type=style&index=0&id=715eddfd&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__